export default __webpack_public_path__ + "static/media/icon-viber.70e27e9e.svg";